import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ScreeningVerdict } from '../../data/screening-results.model';

/** Word + icon + colour. Never colour alone. */
const VERDICT_LABEL: Record<ScreeningVerdict, string> = {
  passed: 'Passed',
  flagged: 'Flagged',
  failed: 'Failed',
  progress: 'Screening',
  queued: 'Queued',
};

const VERDICT_CLASS: Record<ScreeningVerdict, string> = {
  passed: 'bg-green-50 text-green-700 dark:bg-green-400/10 dark:text-green-400',
  flagged: 'bg-amber-50 text-amber-700 dark:bg-amber-400/10 dark:text-amber-300',
  failed: 'bg-red-50 text-red-700 dark:bg-red-400/10 dark:text-red-400',
  progress: 'bg-brand-studio/10 text-brand-studio-dark dark:text-brand-studio',
  queued: 'bg-muted text-muted-foreground',
};

@Component({
  selector: 'scr-verdict-pill',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './verdict-pill.html',
})
export class VerdictPill {
  readonly verdict = input.required<ScreeningVerdict>();
  readonly size = input<'sm' | 'lg'>('sm');

  readonly label = computed(() => VERDICT_LABEL[this.verdict()]);
  readonly toneClass = computed(() => VERDICT_CLASS[this.verdict()]);
  readonly sizeClass = computed(() =>
    this.size() === 'lg' ? 'px-3.5 py-1.5 text-xs' : 'px-2.5 py-1 text-[11px]',
  );
}
